import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import securityPoliciesTokens from "screens/Settings/SecurityPolicies/SecurityPolicies.tokens";

const { leadingIcon, allowlistCard, activityLink } = securityPoliciesTokens;

interface GlyphProps extends SvgIconProps {
  size: number;
  strokeColor: string;
  /** Matches `SvgIconProps["strokeWidth"]` so callers can spread it through. */
  strokeWidth: number | string;
}

/**
 * Thin stroked glyphs traced from the Security Policies design.
 * `@mui/icons-material` ships filled shapes, so these are drawn here with the
 * exact stroke weight, colour and size the design specifies.
 */
const Glyph: React.FC<GlyphProps> = ({
  size,
  strokeColor,
  strokeWidth,
  children,
  sx,
  ...rest
}) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      // SvgIcon sets `fill: currentColor`, which would beat the `fill="none"`
      // attribute and flood the outline glyph.
      fill: "none",
      ...sx,
    }}
    {...rest}
  >
    {children}
  </SvgIcon>
);

/** Phone glyph in the "Enforce Multi-Factor Authentication" card. */
export const MobileDeviceIcon: React.FC<SvgIconProps> = (props) => (
  <Glyph
    size={leadingIcon.glyphSize}
    strokeColor={leadingIcon.glyphColor}
    strokeWidth={leadingIcon.glyphStrokeWidth}
    {...props}
  >
    <rect x="6" y="2" width="12" height="20" rx="2" />
    <path d="M12 18h.01" />
  </Glyph>
);

/** Shield glyph in the "Enforce IP allowlist" banner. */
export const ShieldIcon: React.FC<SvgIconProps> = (props) => (
  <Glyph
    size={allowlistCard.glyphSize}
    strokeColor={allowlistCard.glyphColor}
    strokeWidth={allowlistCard.glyphStrokeWidth}
    {...props}
  >
    <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
  </Glyph>
);

/** Clock glyph leading the "Activity Log" action. */
export const ActivityLogIcon: React.FC<SvgIconProps> = (props) => (
  <Glyph
    size={activityLink.glyphSize}
    strokeColor="currentColor"
    strokeWidth={activityLink.glyphStrokeWidth}
    {...props}
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 3" />
  </Glyph>
);
